import { useRequest } from "hooks";
import type { ID, ResourceResponse, ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { BankingSdkConnectorsRecipientsPivot, BankingSdkConnectorsRecipientsPivotResponse } from "../types";
import {
    createBankingSdkConnectorsRecipientsPivotThunk,
    deleteBankingSdkConnectorsRecipientsPivotThunk,
    getBankingSdkConnectorsRecipientsPivotThunk,
    updateBankingSdkConnectorsRecipientsPivotThunk
} from "../thunks";
import { changeExportBankingSdkConnectorsRecipientsPivotLoading as changeExportLoading } from "../slice";

export const useBankingSDKConnectorsRecipientsPivotActions = () => {
    const getBankingSDKConnectorsRecipientsPivot = useRequest<
        ThunkReturnType<BankingSdkConnectorsRecipientsPivotResponse>,
        string | undefined
    >({
        thunk: getBankingSdkConnectorsRecipientsPivotThunk
    });

    const createBankingSDKConnectorsRecipientsPivot = useRequest<
        ThunkReturnType<ResourceResponse<BankingSdkConnectorsRecipientsPivot>>,
        Partial<BankingSdkConnectorsRecipientsPivot>
    >({
        thunk: createBankingSdkConnectorsRecipientsPivotThunk
    });

    const updateBankingSDKConnectorsRecipientsPivot = useRequest<
        ThunkReturnType<ResourceResponse<BankingSdkConnectorsRecipientsPivot>>,
        Partial<BankingSdkConnectorsRecipientsPivot>
    >({
        thunk: updateBankingSdkConnectorsRecipientsPivotThunk
    });

    const deleteBankingSDKConnectorsRecipientsPivot = useRequest<
        ThunkReturnType<ResourceResponse<ID>>,
        Pick<BankingSdkConnectorsRecipientsPivot, 'coreId'>
    >({
        thunk: deleteBankingSdkConnectorsRecipientsPivotThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetBankingSdkConnectorsRecipientsPivot
    });

    return {
        getBankingSDKConnectorsRecipientsPivot,
        createBankingSDKConnectorsRecipientsPivot,
        updateBankingSDKConnectorsRecipientsPivot,
        deleteBankingSDKConnectorsRecipientsPivot,
        downloadCsv
    };
};

export default useBankingSDKConnectorsRecipientsPivotActions;
